const formatFilterValue = (value) => {
  const isEmptyArray = Array.isArray(value) && !value.length;
  if (isEmptyArray) {
    return;
  }
  return value;
};
export {
  formatFilterValue
};
